import { Inject, Injectable } from '@angular/core';
import { Auth, authState } from '@angular/fire/auth';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private router: Router, @Inject('FIREBASE_AUTH') private auth: Auth) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const user = await firstValueFrom(authState(this.auth));
    if (!!user) {
      return true;
    }

    // not logged in so redirect to login page with the return url
    if (state.url.startsWith('/sign-in')) {
      return true;
    } else {
      const newQueryParams = state.url.length > 1 ? { redirect: state.url } : {};
      this.router.navigate(['/sign-in'], {
        queryParams: newQueryParams,
      });
    }

    return false;
  }
}
